import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Question asked in a confirmation dialog before the form is sent. Cancel sends nothing. Leave it empty to send at once.
   *
   * @type {String}
   * @default undefined
   */
  confirm: {
    type: String,
    default: undefined,
  },
  /**
   * Let the browser submit the form after the confirmation, so the page follows the server's answer. Only `action-send`
   * is dispatched; the pressed item stays pending until the page leaves, or is restored at once when the form targets
   * another window.
   *
   * @type {Boolean|String}
   * @default false
   */
  navigate: booleanAttribute(),
});
